<template>
    <div class="nav-wrapper">
        <div class="nav-fold boxHover" @click="toggleOpen"><i class="el-icon-s-fold"></i></div>
        <div class="nav-wrapper-tagview">
            <tag-view></tag-view>
        </div>
        <div class="right-menu">
            <div class="right-menu-item">
                <div class="right-menu-date">
                    <i class="el-icon-date"></i><strong>{{timeZoneDate}}</strong>
                </div>
            </div>
            <div class="right-menu-item">
                <div class="right-menu-national">
                    <div class="text">{{countryText}}</div>
<!--                    <div class="text">
                        <el-tooltip :content="user.timeZone" placement="top">
                            <div v-if="user.timeZone==='America/Mexico_City'">MXN</div>  &lt;!&ndash;墨西哥&ndash;&gt;
                            <div v-if="user.timeZone==='Asia/Kolkata'">INR</div>  &lt;!&ndash;印度&ndash;&gt;
                            <div v-if="user.timeZone==='America/Bogota'">COP</div>  &lt;!&ndash;哥伦比亚&ndash;&gt;
                            <div v-if="user.timeZone==='Africa/Lagos'">NGN</div>  &lt;!&ndash;尼日利亚&ndash;&gt;
                            <div v-if="user.timeZone==='America/Lima'">PEN</div>  &lt;!&ndash;秘鲁&ndash;&gt;
                            <div v-if="user.timeZone==='Asia/Karachi'">PKR</div>  &lt;!&ndash;巴基斯坦&ndash;&gt;
                        </el-tooltip>
                    </div>-->
                </div>
            </div>
<!--            <div class="right-menu-item">
                <div class="right-menu-message">
                    <span>...</span>
                    <i class="el-icon-message-solid"></i>
                </div>
            </div>-->
            <div class="right-menu-item">
                <div class="right-menu-user">
                    <div class="photo">
                        <img :src="userPhoto" alt="" />
                    </div>
                    <!-- 用户名下拉菜单 -->
                    <el-dropdown class="user-name">
                        <span class="el-dropdown-link">
                            {{user.username}}
                            <i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="passwordOpen">修改密码</el-dropdown-item>
                            <el-dropdown-item divided @click.native="logout">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters,mapMutations,mapActions,mapState} from 'vuex'
import tagView from "@/layouts/components/tagView";
export default{
    name: "vHeader",
    data(){
        return{
            userPhoto:require('@/assets/male-big.jpeg'),
            timer:'',
        }
    },
    computed:{
        ...mapGetters(['open','timeZoneDate']),
        countryText(){
            if(this.user.countryCode==='MX'){
                return '墨西哥/MX'
            }
            if(this.user.countryCode==='CO'){
                return '哥伦比亚/CO'
            }
            if(this.user.countryCode==='NG'){
                return '尼日利亚/NG'
            }
            if(this.user.countryCode==='PE'){
                return '秘鲁/PE'
            }
            if(this.user.countryCode==='PK'){
                return '巴基斯坦/PK'
            }
            if(this.user.countryCode==='CL'){
                return '智利/CL'
            }
            return this.user.countryCode
        },
        user(){
            return this.$store.getters.getUsers
        },
    },
    methods:{
        ...mapActions(['getOpen','getTimeZoneDate']),
        logout(){
            const loading = this.$loading({lock: true,});
            this.$http('/logout',{method:'get',params:{}}).then(res=>{
                console.log('退出登录=========>',res);
                clearInterval(this.timer);
                localStorage.removeItem('user');
                this.$store.dispatch('actionUserSignout');
                this.$store.dispatch('CLEAR_TAGS');
                this.$router.replace({path:'/login'});
                loading.close();
            }).catch(err=>{
                loading.close();
                this.$message.error(err.respMsg)
            })
        },
        toggleOpen() {
            this.getOpen(!this.open);
        },
        passwordOpen(){
            this.$store.commit('PASSWORD_VISIBLE');
        },
    },
    components:{
        tagView,
    },
    mounted(){
        this.timer=setInterval(this.getTimeZoneDate,1000);
    }
}
</script>



// WEBPACK FOOTER //
// src/layouts/components/vHeader.vue